import PropTypes from 'prop-types';
import React from 'react';
import {isEmpty} from 'lodash';

export default function ModuleTitle({ title, largeTitle }) {
  if (isEmpty(title) || title === 'untitled') {
    return null;
  }

  return (
    <header className="module-header">
      <div className="container">
        { largeTitle && <h2 className="large-title">{largeTitle}</h2> }
        <h2 className="title">{title}</h2>
      </div>
    </header>
  );
}

ModuleTitle.propTypes = {
  title: PropTypes.string,
  largeTitle: PropTypes.string
};
